/* Torpion V – Header, Hero-Slider, Karussell, Lazy-Videos */
(function(){
  "use strict";
  var reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* ---------- transparenter Header über dem Hero (nur Startseite) ---------- */
  var header = document.querySelector('header.nav[data-transparent="true"]');
  if (header && document.body.classList.contains("template-index")) {
    var mm = document.getElementById("mobileMenu");
    var onScroll = function(){
      var solid = window.scrollY > 40 || (mm && mm.classList.contains("open"));
      header.classList.toggle("is-solid", !!solid);
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    if (mm && "MutationObserver" in window) {
      new MutationObserver(onScroll).observe(mm, { attributes: true, attributeFilter: ["class"] });
    }
    onScroll();
  }

  /* ---------- Hero-Slider ---------- */
  document.querySelectorAll("[data-hero-slider]").forEach(function(root){
    var slides = [].slice.call(root.querySelectorAll(".hs-slide"));
    var dots = [].slice.call(root.querySelectorAll(".hs-dot"));
    if (!slides.length) return;
    var speed = parseInt(root.getAttribute("data-speed"), 10) || 6000;
    var auto = root.getAttribute("data-autoplay") === "true" && !reduce && slides.length > 1;
    root.style.setProperty("--hs-speed", (speed / 1000) + "s");
    if (!auto) root.classList.add("no-auto");
    var i = 0, timer = null;

    function vid(s, on){
      var v = s.querySelector("video");
      if (!v) return;
      if (on) {
        v.muted = true;
        if (v.preload === "none") v.preload = "auto";
        var p = v.play(); if (p && p.catch) p.catch(function(){});
      } else { v.pause(); }
    }
    function warm(n){
      var s = slides[(n + slides.length) % slides.length];
      var v = s && s.querySelector("video");
      if (v && v.preload === "none") v.preload = "metadata";
    }
    function restart(){
      clearTimeout(timer);
      if (auto && !document.hidden) timer = setTimeout(function(){ go(i + 1); }, speed);
    }
    function mark(n, on){
      var s = slides[n];
      s.classList.toggle("is-active", on);
      if (on) { s.removeAttribute("aria-hidden"); s.removeAttribute("inert"); }
      else { s.setAttribute("aria-hidden", "true"); s.setAttribute("inert", ""); }
      vid(s, on);
      var d = dots[n];
      if (d) {
        d.classList.remove("is-active");
        if (on) { void d.offsetWidth; d.classList.add("is-active"); }
        d.setAttribute("aria-current", on ? "true" : "false");
      }
    }
    function go(n){
      n = (n + slides.length) % slides.length;
      if (n === i) { restart(); return; }
      mark(i, false); i = n; mark(i, true); warm(i + 1); restart();
    }

    dots.forEach(function(d, idx){ d.addEventListener("click", function(){ go(idx); }); });
    var prev = root.querySelector("[data-hs-prev]"), next = root.querySelector("[data-hs-next]");
    prev && prev.addEventListener("click", function(){ go(i - 1); });
    next && next.addEventListener("click", function(){ go(i + 1); });

    var x0 = null;
    root.addEventListener("touchstart", function(e){ x0 = e.touches[0].clientX; }, { passive: true });
    root.addEventListener("touchend", function(e){
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0; x0 = null;
      if (Math.abs(dx) > 50) go(dx < 0 ? i + 1 : i - 1);
    });
    root.addEventListener("keydown", function(e){
      if (e.key === "ArrowRight") go(i + 1);
      if (e.key === "ArrowLeft") go(i - 1);
    });
    document.addEventListener("visibilitychange", function(){
      if (document.hidden) { clearTimeout(timer); vid(slides[i], false); }
      else { vid(slides[i], true); restart(); }
    });

    mark(0, true); warm(1); restart();
  });

  /* ---------- Produkt-Karussell ---------- */
  document.querySelectorAll("[data-carousel]").forEach(function(w){
    var t = w.querySelector(".pc-track");
    if (!t) return;
    var p = w.querySelector("[data-prev]"), n = w.querySelector("[data-next]");
    function step(){ var c = t.children[0]; return c ? c.getBoundingClientRect().width + 18 : t.clientWidth; }
    function upd(){
      if (p) p.disabled = t.scrollLeft <= 4;
      if (n) n.disabled = t.scrollLeft + t.clientWidth >= t.scrollWidth - 4;
    }
    p && p.addEventListener("click", function(){ t.scrollBy({ left: -step(), behavior: reduce ? "auto" : "smooth" }); });
    n && n.addEventListener("click", function(){ t.scrollBy({ left: step(), behavior: reduce ? "auto" : "smooth" }); });
    t.addEventListener("scroll", upd, { passive: true });
    window.addEventListener("resize", upd);
    [].forEach.call(t.querySelectorAll(".reveal"), function(el){ el.classList.add("in"); });
    upd();
  });

  /* ---------- Spotlight-Videos erst abspielen, wenn sichtbar ---------- */
  var lazyVids = document.querySelectorAll(".bs-media video");
  if (lazyVids.length && !reduce && "IntersectionObserver" in window) {
    var vio = new IntersectionObserver(function(es){
      es.forEach(function(e){
        var v = e.target;
        if (e.isIntersecting) {
          v.muted = true;
          if (v.preload === "none") v.preload = "auto";
          var pr = v.play(); if (pr && pr.catch) pr.catch(function(){});
        } else { v.pause(); }
      });
    }, { rootMargin: "200px 0px" });
    lazyVids.forEach(function(v){ vio.observe(v); });
  }
})();
